<template>
    <div id="goldbuch">
        <v-toolbar flat color="white" id="toolbar">
            <v-toolbar-title class="blue--text text--darken-4" @click="laden()"
            >Goldbuch
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>

            <v-spacer></v-spacer>

            <v-text-field
                    append-icon="search"
                    label="Suche"
                    v-model="suche"
                    single-line
                    hide-details
            ></v-text-field>

            <v-layout row justify-end>
                <v-dialog v-model="dialog" max-width="800px" :persistent="true">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-2" v-on="on"
                        >Neuer Eintrag
                        </v-btn>
                    </template>

                    <v-card>
                        <VorgangForm
                                :dialog="dialog"
                                :eintrag="eintrag"
                                @close="dialog = false"
                        ></VorgangForm>
                    </v-card>
                </v-dialog>
            </v-layout>

            <v-layout row justify-end>
                <v-dialog
                        v-model="dialogVorschau"
                        max-width="500px"
                        :persistent="false"
                >
                    <v-card>
                        <v-card-title class="headline">
                            Eintrag vom {{ eintrag.datum | datum("DD.MM.YYYY") }}
                        </v-card-title>
                        <v-card-text v-if="dialogVorschau">
                            <table class="vorschau">
                                <tbody>
                                <tr>
                                    <td>Datum</td>
                                    <td>{{ eintrag.datum }}</td>
                                </tr>
                                <tr>
                                    <td>Techniker</td>
                                    <td>{{ eintrag.techniker.nummer }}</td>
                                </tr>
                                <tr>
                                    <td>Zahnarzt</td>
                                    <td>{{ eintrag.arzt.name }}</td>
                                </tr>
                                <tr>
                                    <td>Patient</td>
                                    <td>{{ eintrag.adresse.name }}</td>
                                </tr>
                                <tr>
                                    <td>Art der Arbeit</td>
                                    <td>{{ eintrag.arbeitsart.name }}</td>
                                </tr>
                                <tr>
                                    <td>Material</td>
                                    <td>{{ eintrag.material.name }}</td>
                                </tr>
                                <tr>
                                    <td>Gussgewicht</td>
                                    <td>{{ eintrag.gussgewicht }}</td>
                                </tr>
                                <tr>
                                    <td>Kommentar</td>
                                    <td>{{ eintrag.kommentar }}</td>
                                </tr>
                                </tbody>
                            </table>

                            <div id="protokoll" v-if="eintrag.protokoll.length">
                                <h3 class="mb-1">Änderungen</h3>
                                <ul>
                                    <li v-for="prot in orderedProtokoll" :key="prot.id">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th>
                                                    <b>{{
                                                        prot.created_at | datum("DD.MM.YYYY HH:mm")
                                                        }}</b>
                                                </th>
                                                <th>ALT</th>
                                                <th>NEU</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="data in prot.data" :key="data.id">
                                                <td>{{ data.typ }}</td>
                                                <td>{{ data.alt }}</td>
                                                <td>{{ data.neu }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </li>
                                </ul>
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" flat="flat" @click="bearbeiten(eintrag)"
                            >Bearbeiten
                            </v-btn>

                            <v-btn
                                    color="black darken-5"
                                    flat="flat"
                                    @click="dialogVorschau = false"
                            >
                                Abbrechen
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-toolbar>

        <v-layout class="mt-4">
            <v-flex>
                <v-data-table
                        :headers="headers"
                        :items="vorgaenge"
                        :search="suche"
                        :pagination.sync="pagination"
                        rows-per-page-text="Vorgänge pro Seite"
                >
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                            Your search for "{{ search }}" found no results.
                        </v-alert>
                    </template>

                    <template v-slot:items="props">
                        <tr
                                @click="vorschau(props)"
                                :class="{ mitAenderung: props.item.protokoll.length > 0, mitKommentar: props.item.kommentar }"
                        >
                            <td>{{ props.item.datum | datum("DD.MM.YYYY") }}</td>
                            <td>{{ props.item.techniker.nummer }}</td>
                            <td>{{ props.item.arzt.name }}</td>
                            <td>{{ props.item.patient || props.item.adresse.name }}</td>
                            <td>{{ props.item.arbeitsart.name }}</td>
                            <td>{{ props.item.material.name }}</td>
                            <td>{{ props.item.gussgewicht | gewicht() }}</td>
                        </tr>
                    </template>

                    <template v-slot:pageText="props">
                        Einträge {{ props.pageStart }} - {{ props.pageStop }} von
                        {{ props.itemsLength }}
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import * as _ from "lodash";
    import {mapState} from "vuex";
    import VorgangForm from "@/components/VorgangForm.vue";

    export default {
        name: "Goldbuch",
        components: {
            VorgangForm
        },
        data() {
            return {
                dialog: false,
                dialogVorschau: false,
                valid: false,
                confirmMaterial: false,
                suche: "",
                eintrag: {},
                pagination: {
                    sortBy: "datum",
                    descending: true,
                    page: 1,
                    rowsPerPage: 25,
                    rowsPerPageItems: [25, 50, 100]
                },
                headers: [
                    {
                        text: "Datum",
                        align: "left",
                        // sortable: false,
                        value: "datum"
                    },
                    {text: "Techniker", value: "techniker.name"},
                    {text: "Zahnarzt", value: "arzt.name"},
                    {text: "Patient", value: "adresse.vorname"},
                    {text: "Art der Arbeit", value: "art"},
                    {text: "Material", value: "material.name"},
                    {text: "Gussgewicht (gr.)", value: "gussgewicht"}
                ],
                name: ""
            };
        },
        mounted() {
            this.laden();
            //this.$validator.localize('de', this.dictionary)
        },
        computed: {
            ...mapState(["vorgaenge"]),
            orderedProtokoll: function () {
                return _.orderBy(this.eintrag.protokoll, ["id"], ["desc"]);
            }
        },
        methods: {
            laden() {
                this.$store.dispatch("loadVorgaenge");
            },
            neuesMaterialAnlegen() {
                this.confirmMaterial = true;
            },
            vorschau(data) {
                this.dialogVorschau = true;
                this.eintrag = data.item;
                // setTimeout(() => {
                //     this.bearbeiten(data);
                // }, 2000);
            },

            bearbeiten() {
                //this.eintrag = data.item;
                this.dialog = true;
            }
        },
        watch: {
            dialog(aktiv) {
                if (!aktiv) {
                    this.eintrag = {};
                }
                this.dialogVorschau = false;
            }
        }
    };
</script>

<style lang="scss">

    .v-table__overflow {
        overflow-x: hidden;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }

    table {
        &.vorschau {
            width: 100%;
            td {
                &:first-child {
                    font-weight: bold;
                    width: 120px;
                    text-align: left;
                }
            }
        }

        tr.mitAenderung {
            td:last-child {
                border-right: 6px solid orange !important;
            }
        }

        tr.mitKommentar {
            td:first-child {
                border-left: 6px solid lightblue !important;
            }
        }

        td {
            border-top-width: 0 !important;
            border-left-width: 0 !important;
            &:last-child {
                border-right-width: 0 !important;
            }
        }
    }

    #protokoll {
        padding: 20px 0;
        table {
            thead {
                tr {
                    background: #e0e0e0;
                    th {
                        padding: 1px 4px;
                        font-weight: normal;
                    }
                }
            }
            width: 100%;
            td:first-child {
                width: 130px;
                font-weight: bold;
                text-transform: capitalize;
            }
            td:last-child {
                width: 160px;
            }
        }

        ul {
            max-height: 200px;
            overflow: auto;
            list-style: none;
            padding: 10px 4px;
            border: 1px solid #dfdfdf;
            li + li {
                margin-top: 20px;
            }
        }
    }
</style>
